import type { MatchSummary } from "../types";

/**
 * Publish a newly-created/joined match before changing routes. The table route resolves entirely
 * from the local match list, so navigating first can briefly—or after a failed write, permanently—
 * render "Game not found" even though Arcade joined the room successfully.
 */
export async function persistMatchBeforeTransition(
  match: MatchSummary,
  currentMatches: readonly MatchSummary[],
  persist: (match: MatchSummary) => Promise<void>,
  publish: (matches: MatchSummary[]) => void,
  transition: () => void,
): Promise<void> {
  await persist(match);
  publish([match, ...currentMatches.filter((item) => item.roomId !== match.roomId)]);
  transition();
}
